import React, { memo } from 'react';
import { motion } from 'framer-motion';
export function SolutionSection() {
  return <section className="bg-navy-dark py-16 md:py-24 px-4" data-id="element-157">
      <div className="max-w-3xl mx-auto" data-id="element-158">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-159">
          <h2 className="text-4xl md:text-5xl font-black text-white mb-10 text-center" data-id="element-160">
            Ahora imaginá esto
          </h2>

          <p className="text-xl text-gray-300 mb-8 text-center" data-id="element-161">
            Abrís tu estudio y…
          </p>

          <div className="bg-navy-light p-8 rounded-2xl border border-green-500/30 shadow-[0_0_30px_rgba(34,197,94,0.1)] mb-10" data-id="element-162">
            <ul className="space-y-6 text-lg md:text-xl" data-id="element-163">
              <li className="flex items-center gap-4" data-id="element-164">
                <span className="bg-green-500/20 text-green-400 p-2 rounded-full" data-id="element-165">
                  ✅
                </span>
                <span className="text-white font-medium" data-id="element-166">
                  Sabés exactamente qué hacer
                </span>
              </li>
              <li className="flex items-center gap-4" data-id="element-167">
                <span className="bg-green-500/20 text-green-400 p-2 rounded-full" data-id="element-168">
                  ✅
                </span>
                <span className="text-white font-medium" data-id="element-169">
                  Cada cliente está registrado
                </span>
              </li>
              <li className="flex items-center gap-4" data-id="element-170">
                <span className="bg-green-500/20 text-green-400 p-2 rounded-full" data-id="element-171">
                  ✅
                </span>
                <span className="text-white font-medium" data-id="element-172">
                  Cada caso tiene seguimiento
                </span>
              </li>
              <li className="flex items-center gap-4" data-id="element-173">
                <span className="bg-green-500/20 text-green-400 p-2 rounded-full" data-id="element-174">
                  ✅
                </span>
                <span className="text-white font-medium" data-id="element-175">
                  Todo está organizado
                </span>
              </li>
              <li className="flex items-center gap-4" data-id="element-176">
                <span className="bg-green-500/20 text-green-400 p-2 rounded-full" data-id="element-177">
                  ✅
                </span>
                <span className="text-white font-medium" data-id="element-178">
                  No dependés de tu memoria
                </span>
              </li>
            </ul>
          </div>

          <div className="text-center space-y-6 text-xl text-gray-300" data-id="element-179">
            <p className="font-medium text-white text-2xl" data-id="element-180">
              Sentís control. Sentís claridad. Sentís que por fin estás
              manejando tu estudio.
            </p>
            <p data-id="element-181">Eso no es suerte.</p>
            <p className="text-3xl font-bold text-gold" data-id="element-182">👉 Es sistema.</p>
          </div>
        </motion.div>
      </div>
    </section>;
}